// extracted by css-extract-rspack-plugin
export default {"settlementQuotaConfig":"settlementQuotaConfig-kdPEum","leftMenu":"leftMenu-BDZcx6","rightTable":"rightTable-xhyA18","rightTableTop":"rightTableTop-pPP_wN"};